"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.AxeWithYetAnotherEventAnalyticsEvent = exports.AxesFinalEventAnalyticsEvent = exports.AxeFinishedAnalyticsRevampAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Fired when Axe finally wraps up the long awaited Analytics overhaul
 */
var AxeFinishedAnalyticsRevampAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('axe_finished_analytics_revamp');
exports.AxeFinishedAnalyticsRevampAnalyticsEvent = AxeFinishedAnalyticsRevampAnalyticsEvent;
/**
 * Second Analytics Event demonstrating an event with all optional Event Properties
 */
var AxeWithYetAnotherEventAnalyticsEvent = (0, util_1.newAnalyticsEventWithOptionalPropertiesFactory)('axe_with_yet_another_event');
exports.AxeWithYetAnotherEventAnalyticsEvent = AxeWithYetAnotherEventAnalyticsEvent;
/**
 * Third and Final Analytics Events with no Event Properties whatsoever
 */
var AxesFinalEventAnalyticsEvent = (0, util_1.newAnalyticsEventFactory)('axes_final_event');
exports.AxesFinalEventAnalyticsEvent = AxesFinalEventAnalyticsEvent;
